<button
    mat-button
    [matMenuTriggerFor]="empresaMenu"
    class="apple-selector-btn"
    matTooltip="Cambiar de empresa activa">
    <div class="btn-content">
        <div class="icon-wrapper">
            <mat-icon [svgIcon]="'heroicons_outline:building-office'"></mat-icon>
        </div>
        <span class="company-name">{{ empresaActualNombre }}</span>
        <mat-icon class="chevron-icon" [svgIcon]="'heroicons_solid:chevron-down'"></mat-icon>
    </div>
</button>

<mat-menu #empresaMenu="matMenu" [xPosition]="'before'" class="apple-dropdown-menu">
    <div class="menu-header">
        <span>Empresas asociadas</span>
    </div>
    <mat-divider class="menu-divider"></mat-divider>
    <div class="menu-items-container">
        <button class="menu-item-btn"
            mat-menu-item
            *ngFor="let empresa of empresas"
            (click)="seleccionarEmpresa(empresa)"
            [class.is-active]="empresa.id === empresaActualId">
            <div class="item-layout">
                <div class="item-main">
                    <mat-icon class="item-icon" [svgIcon]="'heroicons_outline:building-office'"></mat-icon>
                    <span class="item-name">{{ empresa.descripcion }}</span>
                </div>
                <mat-icon class="check-icon" *ngIf="empresa.id === empresaActualId" [svgIcon]="'heroicons_solid:check'"></mat-icon>
            </div>
        </button>
    </div>
</mat-menu>
